import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "@store/middleware";

import { applicationUrl } from "@constants";
import { bookingMetadataTypes } from "@shared/constants/bookingMetadataTypes";
import { type IBookingMetadata } from "@types";

export const BOOKING_METADATA_REDUCER_KEY = "bookingMetadata";
export const bookingMetadataApi = createApi({
  reducerPath: BOOKING_METADATA_REDUCER_KEY,
  baseQuery: baseQueryWithAuth({ baseUrl: applicationUrl }),
  endpoints: (builder) => ({
    getBookingMetadata: builder.query<IBookingMetadata[], void>({
      query: () => ({
        url: "/api/user/booking-metadata",
        method: "GET",
      }),
    }),
    postBookingMetadata: builder.mutation<void, IBookingMetadata["data"]>({
      query: (metadata) => ({
        url: "/api/user/booking-metadata",
        method: "POST",
        body: { type: bookingMetadataTypes.inputMeetingData, data: metadata },
      }),
    }),
    putBookingMetadata: builder.mutation<void, { id: IBookingMetadata["id"]; metadata: IBookingMetadata["data"] }>({
      query: ({ id, metadata }) => ({
        url: `/api/user/booking-metadata/${id}`,
        method: "PUT",
        body: { type: bookingMetadataTypes.inputMeetingData, data: metadata },
      }),
    }),
    sendMeetingTokenEmail: builder.mutation<void, { userEmail: string; oldUrl: string }>({
      query: (data) => ({
        url: "/api/send-meeting-token-email",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetBookingMetadataQuery,
  useLazyGetBookingMetadataQuery,
  usePostBookingMetadataMutation,
  usePutBookingMetadataMutation,
  useSendMeetingTokenEmailMutation,
} = bookingMetadataApi;
